<template>
  <v-footer 
    :inset="footer.inset"
    height="auto"
    class="px-0 py-0 custom-footer-position"
    app
  >
       <span class="px-4 footer-white--text caption">
           <img class="doggo-one" :src="footer_icon" alt="Sweep and Go Logo" /> Copyright &copy; {{ new Date().getFullYear() }} All rights reserved.
           Sweep&amp;Go is a registered trademark of OGO Sense LLC.</span>
    </v-footer>
</template>

<script>
  export default {
    data: () => ({
      footer_icon: require('@/assets/img/logo/footer-logo.png'),
      footer: {
        inset: true
      }
    })
  }
</script>

<style lang="css">
.footer-white--text img{
    width: 20px;
    vertical-align: baseline;
    margin-right: 5px;
}
.custom-footer-position {
  position: absolute!important;
}
.footer-white--text {
    color: rgba(0, 0, 0, 0.80)!important;
    width: 100%;
    margin: 0px auto;
    border-top: 1px solid #C2C2C2;    
    padding-top: 15px;
    padding-bottom: 15px;
    text-align: center;
    background: white;
}
</style>
